import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import {
  Image,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';

const ImagePreviewContext = createContext({ openPreview: () => {} });

export const useImagePreview = () => useContext(ImagePreviewContext);

const shouldSkip = (img) => {
  if (!img || img.tagName !== 'IMG') return true;
  if (img.closest('[data-no-image-preview]')) return true;
  if (img.closest('[data-image-preview-modal]')) return true;
  const alt = (img.alt || '').toLowerCase();
  if (alt === 'logo') return true;
  const src = img.currentSrc || img.src || '';
  if (!src) return true;
  if (src.includes('logo2.png') || src.includes('logoWhite')) return true;
  return false;
};

export const ImagePreviewProvider = ({ children }) => {
  const [preview, setPreview] = useState(null);

  const openPreview = useCallback((src, alt = 'Image preview') => {
    if (!src) return;
    setPreview({ src, alt });
  }, []);

  useEffect(() => {
    const onClick = (event) => {
      const img = event.target?.closest?.('img');
      if (shouldSkip(img)) return;
      event.preventDefault();
      event.stopPropagation();
      openPreview(img.currentSrc || img.src, img.alt);
    };

    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, [openPreview]);

  return (
    <ImagePreviewContext.Provider value={{ openPreview }}>
      {children}
      <Modal isOpen={!!preview} onClose={() => setPreview(null)} size="4xl" isCentered>
        <ModalOverlay bg="rgba(7, 50, 5, 0.72)" backdropFilter="blur(8px)" />
        <ModalContent
          bg="transparent"
          boxShadow="none"
          border="none"
          maxW="90vw"
          data-image-preview-modal=""
        >
          <ModalCloseButton color="white" zIndex={2} />
          {preview && (
            <Image
              src={preview.src}
              alt={preview.alt}
              maxH="85vh"
              maxW="90vw"
              mx="auto"
              objectFit="contain"
              borderRadius="md"
            />
          )}
        </ModalContent>
      </Modal>
    </ImagePreviewContext.Provider>
  );
};

export default ImagePreviewProvider;
